export default "__VITE_ASSET__DoxpDauU__"